// componente utilizzata per mostrare la pagina di gestione pannelli; la prima e unica funzione richiamata è la lettura
// dei pannelli mediante apposito servizio di back-end

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'settingsTot',
  templateUrl: './settingsComplete.html',
  styleUrls: ['./style.scss']
})

export class SettingsTabComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
